<div class="box" [class.margin-top]="marginTop" [class.margin-bottom]="marginBottom" [class.success]="isSuccess" [class.warning]="isWarning" [class.danger]="isDanger" [class.info]="isInfo" [class.success]="isSuccess2">
    <div class="min-width">
    <mat-icon *ngIf="isSuccess2">check_circle</mat-icon>
    <mat-icon *ngIf="isDanger">warning</mat-icon>
    </div>
    <ng-content></ng-content>
  </div>